const getWindowEnv = () => {
  if (typeof window === 'undefined' || !window.ENV || typeof window.ENV !== 'object') {
    return {};
  }

  return window.ENV;
};

const getConfigMode = () => {
  const runtimeEnv = getWindowEnv();
  const configuredMode = runtimeEnv.CONFIG || process.env.REACT_APP_CONFIG || process.env.CONFIG || 'Development';

  return String(configuredMode).trim().toLowerCase();
};

export const isProductionRuntime = () => getConfigMode() === 'production';

export const resolveBackendApiBaseUrl = () => {
  const runtimeEnv = getWindowEnv();
  const candidates = [
    runtimeEnv.REACT_APP_API_URL,
    process.env.REACT_APP_API_URL,
  ];

  const resolved = candidates.find(
    (value) => typeof value === 'string' && value.trim() && !/placeholder/i.test(value)
  );

  return resolved ? resolved.trim() : '';
};

export const resolveAnythingLlmBaseUrl = () => {
  if (!isProductionRuntime()) {
    return '';
  }

  const runtimeEnv = getWindowEnv();
  const candidates = [
    runtimeEnv.PRODUCTION_IP_BASE_URL,
    process.env.PRODUCTION_IP_BASE_URL,
  ];

  const resolved = candidates.find(
    (value) => typeof value === 'string' && value.trim() && !/placeholder/i.test(value)
  );

  return resolved ? resolved.trim() : '';
};

export const resolveApiBaseUrl = resolveBackendApiBaseUrl;